import { FC } from 'react'
import { Typography } from '@mui/material'
import { DialogNames } from 'src/enums'
import { SensorModal } from './sensorModal'

interface Props {
  sensorDeviceId: string
  onSubmit: () => void
  onCancel: () => void
  isLoading?: boolean
  deviceType?: 'sensor' | 'gateway'
}

export const MakeAvailableSensorModal: FC<Props> = ({ sensorDeviceId, onSubmit, onCancel, isLoading = false, deviceType = 'sensor' }) => {
  return (
    <SensorModal
      dialogName={DialogNames.UnarchiveSensor}
      onSubmit={onSubmit}
      onCancel={onCancel}
      isLoading={isLoading}
      actionButtonName="Make available"
      content={
        <Typography variant="h6">
          Are you sure you want to make available the {deviceType === 'sensor' ? 'sensor' : 'gateway'} "{sensorDeviceId}"? It will be moved to "new" status.
        </Typography>
      }
    />
  )
}
